const apiClient = require('../graphql/apiClient')
const { hideRadarArea, isViewEnabled, initialisePage, hideLoader, getRootContent } = require('../utils/headers')
const { getCellColor, getTableHeadingRow } = require('../utils/formattingUtils')

const _ = require('lodash')

const { gql } = require('graphql-tag')

const EMERGING_QUERY = gql`
  query emergingBlips($statuses: [Status]) {
    blips(statuses: $statuses) {
      id
      name
      link
      labels
      quadrant {
        name
      }
      created
      reporter
    }
  }
`

const VIEW_MODE = 'emerging'

function renderView() {
  if (isViewEnabled(VIEW_MODE)) {
    hideRadarArea()

    initialisePage('Emerging Blips', 'Blips which are in our backlog and ready to be placed on the radar 📍')

    var bodyText = ''

    apiClient(EMERGING_QUERY, {
      statuses: ['BLIP_TO_DISCUSS'],
    })
      .then((res) => res.json())
      .then((result) => {
        const data = result.data.blips
        const sortedData = _.sortBy(data, ['quadrant.name', 'name'])
        const groupedBlips = _(sortedData)
          .groupBy((blip) => blip.quadrant.name)
          .value()

        bodyText += '<table>'
        bodyText += getTableHeadingRow(groupedBlips)
        bodyText += '<tr>'

        let colorIndex = 0

        _.map(groupedBlips, function (value) {
          bodyText += `<td style="background-color: ${getCellColor(colorIndex)};">`

          _.each(value, function (blip) {
            bodyText += `<div>
                <a href="${blip.link}" target="_blank">${blip.id}</a>: ${blip.name}<br />
                <div style="margin-left: 5px;">
                  <font size="2">
                    <div><strong>Created by: </strong><i>${blip.reporter}</i></div>
                    <div><strong>Created on: </strong><i>${new Date(blip.created).toDateString()}</i></div>
                    <div><strong>Labels: </strong><i>${blip.labels.join(", ")}</i></div>
                  </font>
                </div>
              </div><br />`
          })
          colorIndex += 1
          bodyText += '</td>'
        })

        bodyText += '</tr></table>'
      })
      .then(() => {
        hideLoader()
        getRootContent().append('div').attr('id', 'radar-table').append('div').attr('id', 'emerging-blips').html(bodyText)
      })
  }
}

module.exports = renderView
